import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { AiAgentService } from '../ai-agent.service';
import { AiAgent } from '../ai-agent';
import { AiAgentComponent } from '../ai-agent/ai-agent.component';

@Component({
    selector: 'app-ai-agent-list',
    templateUrl: './ai-agent-list.component.html',
    styleUrls: ['./ai-agent-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class AiAgentListComponent implements OnInit {
	categories: any[]=[];
	constructor(
		private aiAgentService: AiAgentService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.categories = aiAgentService.categories;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	aiAgents: any;
	aiAgent: AiAgent;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'createDate', header: 'Create Date', width: 'auto' },
		{ field: 'lastUpdate', header: 'Last Update', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.aiAgentId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-aiAgent-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.aiAgentService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.aiAgents = res.data.aiAgents;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.aiAgents = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(aiAgent: AiAgent) {
		try {
			this.formLoading = true;
			this.aiAgentService.update(aiAgent)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.aiAgents.map((aiAgent, i) => {
							if (aiAgent.aiAgentId === res.data.aiAgent.aiAgentId) {
								this.aiAgents[i] = res.data.aiAgent;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(aiAgent: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(aiAgent));

			this.formLoading = true;
			this.aiAgentService.delete(aiAgent.aiAgentId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.aiAgents.splice(this.aiAgents.indexOf(aiAgent), 1);
						this.recordTotal = this.aiAgents.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'AiAgent ' + aiAgent.aiAgentId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'AiAgent ' + aiAgent.aiAgentId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "65vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add AiAgent'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(AiAgentComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addAiAgentCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(aiAgent: AiAgent) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "65vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			aiAgent: aiAgent,
			title: 'Edit AiAgent'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(AiAgentComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateAiAgentCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteAiAgentCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addAiAgentCB(aiAgent: AiAgent) {
		console.log('Adding AiAgent: ' + JSON.stringify(aiAgent));
		// if we don't have a aiAgents array yet...
		if (!this.aiAgents) {
			this.aiAgents = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.aiAgents.unshift(aiAgent);

		// no idea what this is but it is required to update the array
		this.aiAgents = [...this.aiAgents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AiAgent ' + aiAgent.aiAgentId + ' Added', life: 3000 });
	}

	updateAiAgentCB(aiAgent: AiAgent) {
		console.log('Updating AiAgent: ' + JSON.stringify(aiAgent));
		let itemIndex = this.aiAgents.findIndex((item: any) => item.aiAgentId === aiAgent.aiAgentId);
		this.aiAgents[itemIndex] = aiAgent;

		// no idea what this is but it is required to update the array
		this.aiAgents = [...this.aiAgents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AiAgent ' + aiAgent.aiAgentId + ' Updated', life: 3000 });
	}

	deleteAiAgentCB(aiAgent: AiAgent) {
		console.log('Removing AiAgent: ' + aiAgent);
		this.aiAgents.splice(this.aiAgents.indexOf(aiAgent), 1);
		this.recordTotal = this.aiAgents.length;

		// no idea what this is but it is required to update the array
		this.aiAgents = [...this.aiAgents];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'AiAgent ' + aiAgent.aiAgentId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.aiAgents ? this.first === (this.aiAgents.length - this.rows) : true; }
	isFirstPage(): boolean { return this.aiAgents ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(aiAgent: any) {
		if (aiAgent?.status) {
			const status = this.statuses.find((e: any) => e.value == aiAgent.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getCategoryName(aiAgent: any) {
		if (aiAgent?.category) {
			const status = this.categories.find((e: any) => e.value == aiAgent.category);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
